module.exports = __webpack_public_path__ + "19774dfbb4a84861bc2983c26223c9f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/pinterest_2021_chart.png
// module id = 1704
// module chunks = 0